import axios from "@/axios/axios";
import {UserActivitiesDocument} from "@/interfaces/stats.interface";

export async function UserActivities(): Promise<UserActivitiesDocument[]> {
  try {
    const res = await axios.get('/stats/useractivities')
    return res ? res.data : []
  } catch (e: any) {
    console.log('UserActivities failed', e.message)
    return []
  }
}